import React from 'react';
import { ModalBackground, ModalContainer, ModalWrapper } from './styles';
import { ModalProps } from './types';

const Modal: React.FC<ModalProps> = ({ children, onClick}) => (
    <>
        <ModalBackground onClick={onClick} />
        <ModalContainer>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <ModalWrapper>
                    {children}
                </ModalWrapper>
            </div>
        </ModalContainer>
    </>
);

export default Modal;
